import { useEffect } from "react";

const BASE_URL = "https://vyomtex.com";

function setMeta(attr, name, content) {
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setCanonical(href) {
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export default function Seo({ title, description, path = "/", image, noIndex = false }) {
    useEffect(() => {
        const url = `${BASE_URL}${path}`;
        const fullTitle = title
            ? `${title} — Vyom`
            : "Vyom — Luxury Linen Manufacturer & Exporter from India";

        document.title = fullTitle;

        if (description) {
            setMeta("name", "description", description);
            setMeta("property", "og:description", description);
            setMeta("name", "twitter:description", description);
        }
        setMeta("property", "og:title", fullTitle);
        setMeta("name", "twitter:title", fullTitle);
        setMeta("property", "og:url", url);
        setMeta("property", "og:type", "website");

        if (image) {
            setMeta("property", "og:image", image);
            setMeta("name", "twitter:image", image);
        }

        setMeta(
            "name",
            "robots",
            noIndex
                ? "noindex, follow"
                : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        );

        setCanonical(url);
    }, [title, description, path, image, noIndex]);

    return null;
}
